const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Resolves a commerce_theme image object ({ source_type, media_id,
// external_url, ... }, see backend/commerce_theme.py) into an actual URL a
// browser can load. Used by both the storefront and the theme editor's live
// preview/image picker so they agree on the same image regardless of source.
export const resolveCommerceImageUrl = (image) => {
  if (!image) return null;
  if (image.source_type === 'media' && image.media_id) {
    return `${API}/public/commerce/media/${image.media_id}`;
  }
  return image.external_url || null;
};
